import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    SHIPMENTRELATIONS_FEATURE_KEY,
    ShipmentRelationsPartialState,
    State,
} from './shipment-relations.reducer';

export const getShipmentRelationsState = createFeatureSelector<
    ShipmentRelationsPartialState,
    State
>(SHIPMENTRELATIONS_FEATURE_KEY);

export const getShipmentRelationsLoading = createSelector(
    getShipmentRelationsState,
    (state: State) => state.loading
);

export const getShipmentRelationsError = createSelector(
    getShipmentRelationsState,
    (state: State) => state.error
);

export const getShipmentQuotation = createSelector(
    getShipmentRelationsState,
    (state: State) => state.quotation
);
